<template>
    <modal
        :title="$t('message.loginPersonalize.message.createCustomization')"
        :value="value"
        :maxWidth="500"
        @input="emitInput"
    >
        <app-form
            class="login-personalize-create-modal-form"
            @submit="createStyle"
        >
            <text-field
                v-model="title"
                :name="$t('message.trackers.message.name')"
                :label="$t('message.trackers.message.name')"
                :error-messages="
                    errors.collect($t('message.trackers.message.name'))
                "
                validate="required"
            ></text-field>

            <SSIDFilter
                v-if="!isPartner"
                v-model="ssidFilter"
                :is-all-selected="allSsidSelected"
                @update-all-selected="($event) => (allSsidSelected = $event)"
            />

            <app-button
                class="login-personalize-create-modal-form-submit btn btn-round btn-primary"
                :loading="submiting"
                :label="$t('message.loginPersonalize.message.create')"
                type="submit"
            />
        </app-form>
    </modal>
</template>

<script>
import Modal from "@/components/generic/Modal";
import AppButton from "@/components/generic/button/Button";
import AppForm from "@components/form/Form.vue";
import TextField from "@components/form/TextField.vue";
import EventBus from "@packages/event-bus/index";
import SSIDFilter from "../../../ssid/SSIDFilter.vue";

export default {
    components: {
        Modal,
        TextField,
        AppForm,
        AppButton,
        SSIDFilter,
    },

    data() {
        return {
            title: undefined,
            submiting: false,
            ssidFilter: [],
            allSsidSelected: true,
            isPartner: this.$store.state.users.user.tipo === "PARCEIRO"
        };
    },

    props: {
        value: {
            type: Boolean,
        },
    },

    methods: {
        emitInput(val) {
            this.$emit("input", val);
        },
        async createStyle() {
            try {
                this.submiting = true;

                const defaultConfig =
                    await this.$api.core.account.captiveStyle.default();

                const config = {
                    ...defaultConfig,
                    registerStyle: JSON.parse(defaultConfig.registerStyle),
                };

                const newStyle =
                    await this.$api.core.account.captiveStyle.create({
                        isDefault: true,
                        isDefaultGreen: config.isDefaultGreen,
                        registerStyle: JSON.stringify(config.registerStyle),
                        logo: config.logo,
                        phraseLogin: config.phraseLogin,
                        registerBackground: config.registerBackground,
                        registerBackgroundDesktop:
                            config.registerBackgroundDesktop,
                        localItemFilter: [],
                        name: this.title,
                        ssid: this.ssidFilter,
                        allSsidSelected: this.allSsidSelected,
                    });

                this.$router.push(`/personalizar-login/${newStyle.id}`);
            } catch (error) {
                EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: "Selecione o tipo do campo!",
                });
            } finally {
                this.submiting = false;
            }
        },
    },

    watch: {},
};
</script>

<style lang="scss" scoped>
.login-personalize-create-modal-form {
    .login-personalize-create-modal-form-submit {
        margin: 0 auto;
    }
}
</style>
